import FullScreenSpinner from "@/components/generic/FullScreenSpinner";
import { ComponentType, Suspense } from "react";

const Loadable = <P extends object>(Component: ComponentType<P>) => {
  return function LoadableComponent(props: P) {
    return (
      <Suspense fallback={<FullScreenSpinner />}>
        <Component {...props} />
      </Suspense>
    );
  };
};

export default Loadable;
